export const DANG_NHAP = "@quanLyNguoiDungReducer/DANG_NHAP";
export const DANG_KY = "@quanLyNguoiDungReducer/DANG_KY";
export const DANG_XUAT = "@quanLyNguoiDungReducer/DANG_XUAT";
export const LAY_THONG_TIN_NGUOI_DUNG =
  "@quanLyNguoiDungReducer/LAY_THONG_TIN_NGUOI_DUNG";
export const CAP_NHAT_THONG_TIN_NGUOI_DUNG =
  "@quanLyNguoiDungReducer/CAP_NHAT_THONG_TIN_NGUOI_DUNG";
